export class ProgramProgramsOffered {
    public id: number;
    public sports: boolean;
    public homeworkAssistance: boolean;
    public instructionalSupport: boolean;
    public projectBasedEnrichment: boolean;
    public stem: boolean;
    public readingWriting: boolean;
    public careerCollegePrep: boolean;
    public performingArts: boolean;
    public healthAndWellness: boolean;
    public mentoring: boolean;
    public civicEngagement: boolean;
    public familyEngagement: boolean;
    public foodExperiences: boolean;
    public multiCulturalExperiences: boolean;
    public other: boolean;
    public programTypeOther: string;
    public communitySchools: boolean;
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program-programs-offered.ts